import { render } from "./EngineeringDesign.vue?vue&type=template&id=235a2bb9&scoped=true"
import script from "./EngineeringDesign.vue?vue&type=script&lang=js"
export * from "./EngineeringDesign.vue?vue&type=script&lang=js"

import "./EngineeringDesign.vue?vue&type=style&index=0&id=235a2bb9&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/c2stem-server-spice/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235a2bb9"]])

export default __exports__